// Copied from https://github.com/ECFMG/msal-react-lite/tree/f97ae82882ffbc6fbb42405cff5d1f49f0aeda07
import { useContext } from "react";
import MsalContext, { MsalContextInterface } from "./msal-context";

const useMsal = (): MsalContextInterface => useContext(MsalContext);

export default useMsal;
